var tabButton = 'gc39ho1 _14wijgr9';
var tabButtonStrong = 'gc39ho2 _14wijgra';
var tabPanel = 'gc39ho3';
var tabPanelFillHeight = 'gc39ho4';
var tabPanelFillWidth = 'gc39ho5';
var tabStrip = 'gc39ho0';

export { tabButton, tabButtonStrong, tabPanel, tabPanelFillHeight, tabPanelFillWidth, tabStrip };
//# sourceMappingURL=tabs.css.js.map
